import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AdminEmailOption, GopherBuddyCustomerSettings } from '@cdw-ae/common-data';
import { Observable } from 'rxjs';
import { ApiUrlBuilderService } from '../../../../../../common/services/api-url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class GopherBuddySettingsService {
  private readonly http = inject(HttpClient);
  private readonly urlBuilder = inject(ApiUrlBuilderService);

  /**
   * Get list of admin users available for Gopher Buddy
   */
  getAdmins(): Observable<AdminEmailOption[]> {
    const url = this.urlBuilder.backendApi('gopher-buddy', 'admins');
    return this.http.get<AdminEmailOption[]>(url);
  }

  /**
   * Get Gopher Buddy customer settings
   */
  getCustomerSettings(): Observable<GopherBuddyCustomerSettings> {
    const url = this.urlBuilder.backendApi('gopher-buddy', 'settings');
    return this.http.get<GopherBuddyCustomerSettings>(url);
  }

  /**
   * Update Gopher Buddy customer settings
   */
  setCustomerSettings(settings: GopherBuddyCustomerSettings): Observable<{ success: boolean; error?: string }> {
    const url = this.urlBuilder.backendApi('gopher-buddy', 'settings');
    return this.http.post<{ success: boolean; error?: string }>(url, settings);
  }
}
